import { TDataFromStepOne } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

export const calculateServices = (payload: TDataFromStepOne): Promise<any> => {
  return API.post(`/api/accommodation/reservation/calculate`, payload).then(res => res?.data);
};
